<ul class="product-bundle-modules__list">
  <li class="product-bundle-modules__list__item" *ngFor="let m of filteredModuleList; trackBy: trackByFn">
    <img class="product-bundle-modules__list__image" [src]="m.image" [attr.title]="getAltText(m)">
  </li>
</ul>